export default {
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  UPDATE_STOCK_LIST: Symbol('UPDATE_STOCK_LIST'),
  UPDATE_ROOM_STOCK_LIST: Symbol('UPDATE_ROOM_STOCK_LIST'),
  UPDATE_ROOM_STOCK_DATA: Symbol('UPDATE_ROOM_STOCK_DATA'),
  UPDATE_GOODS_LIST: Symbol('UPDATE_GOODS_LIST'),
};
